<script setup lang="ts">
</script>

<template>
	<div class="accordion-container">
		<slot></slot>
	</div>
</template>

<style scoped lang="scss">
.accordion-container {
	border: 1px solid $border-color;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
}
</style>
